import getStaticFile from '@helpers/bucket';

const LIGHT_THEME_PATH = 'icons/lightTheme/logos';
const DARK_THEME_PATH = 'icons/darkTheme/logos';
const NO_THEME_PATH = 'icons/noTheme/logos';

const icon = (path: string, fileName: string) => getStaticFile({ path, fileName });

export const Logo = {
  alt: 'Logo da MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo.svg'),
    height: 32,
    width: 229,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-logo.svg'),
    height: 32,
    width: 229,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-logo.svg'),
    height: 32,
    width: 229,
  },
};

export const LogoHorizontalWhite = {
  alt: 'Logo da MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-logo-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-logo-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
};

export const LogoServicesHorizontalWhite = {
  alt: 'Logo da MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-services-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-logo-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-logo-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
};

export const LogoServicesHorizontalOrange = {
  alt: 'Logo da MadeiraMadeira Serviços',
  light: {
    src: icon(LIGHT_THEME_PATH, 'service-mm-logo-horizontal-orange.svg'),
    height: 31,
    width: 228,
  },
  blackFriday: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-services-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
  dark: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-services-horizontal-white.svg'),
    height: 31,
    width: 228,
  },
};

export const LogoHorizontal = {
  alt: 'Logo da MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-horizontal.svg'),
    height: 29,
    width: 202,
  },
  blackFriday: {
    src: icon(DARK_THEME_PATH, 'mm-logo-horizontal-bf.svg'),
    height: 29,
    width: 202,
  },
  dark: {
    src: icon(DARK_THEME_PATH, 'mm-logo-horizontal-bf.svg'),
    height: 29,
    width: 202,
  },
};

export const LogoOrangeWhite = {
  alt: 'Logo da MadeiraMadeira',
  light: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-orange-white.svg'),
    height: 28,
    width: 202,
  },
  blackFriday: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-orange-white.svg'),
    height: 28,
    width: 202,
  },
  dark: {
    src: icon(LIGHT_THEME_PATH, 'mm-logo-orange-white.svg'),
    height: 28,
    width: 202,
  },
};

export const GoogleGLogo = {
  alt: 'Logo do Google',
  light: {
    src: icon(LIGHT_THEME_PATH, 'google-logo.svg'),
    height: 28,
    width: 202,
  },
  blackFriday: {
    src: icon(LIGHT_THEME_PATH, 'google-logo.svg'),
    height: 28,
    width: 202,
  },
  dark: {
    src: icon(LIGHT_THEME_PATH, 'google-logo.svg'),
    height: 28,
    width: 202,
  },
};

export const CasaTemaLogo = {
  alt: 'Logo do CasaTema',
  light: {
    src: icon(NO_THEME_PATH, 'casatema-logo.svg'),
    height: 64,
    width: 77,
  },
  blackFriday: {
    src: icon(NO_THEME_PATH, 'casatema-logo.svg'),
    height: 64,
    width: 77,
  },
  dark: {
    src: icon(NO_THEME_PATH, 'casatema-logo.svg'),
    height: 64,
    width: 77,
  },
};
